import { Pipe, PipeTransform } from '@angular/core';
import { DateFormat } from '../enums/date-formats.enum';

@Pipe({
  name: 'localizedDate',
  standalone: true,
})
export class LocalizedDatePipe implements PipeTransform {
  transform(
    value: string | Date,
    format: DateFormat = DateFormat.DATETIME
  ): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);

    if (isNaN(date.getTime())) {
      return '';
    }

    let options: Intl.DateTimeFormatOptions = {};

    switch (format) {
      case DateFormat.DATE:
        options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        };
        break;
      case DateFormat.TIME:
        options = {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        };
        break;
      case DateFormat.DATETIME:
      default:
        options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        };
        break;
    }

    return new Intl.DateTimeFormat('pt-BR', {
      ...options,
      timeZone: 'America/Sao_Paulo',
    }).format(date);
  }
}
